module.exports = __webpack_public_path__ + "img/quest_visualization_arrows_1.0821a0c0.svg";